<div class="admin-page-wrap">
  <h1 class="page-title"><i class="bi bi-bell me-2"></i> Notification templates</h1>
  <p class="page-subtitle">Reminder and nudge copy for retention messages. Maps to <code>template_key</code> when reminders ship in Phase 6.</p>

  <div class="card">
    <div class="card-body">
      <div class="d-flex justify-content-end mb-3">
        <button type="button" class="btn btn-primary" (click)="openCreate()">Create template</button>
      </div>
      @if (error) {
        <div class="alert alert-danger">{{ error }}</div>
      }
      @if (message) {
        <div class="alert alert-success">{{ message }}</div>
      }
      @if (loading) {
        <p class="text-muted">Loading…</p>
      } @else {
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th (click)="setSort('triggerKey')" class="sortable"><span class="me-1">Trigger key</span><i [class]="sortIcon('triggerKey')"></i></th>
                <th (click)="setSort('channel')" class="sortable"><span class="me-1">Channel</span><i [class]="sortIcon('channel')"></i></th>
                <th (click)="setSort('headline')" class="sortable"><span class="me-1">Headline</span><i [class]="sortIcon('headline')"></i></th>
                <th (click)="setSort('active')" class="sortable"><span class="me-1">Active</span><i [class]="sortIcon('active')"></i></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (item of sortedContent; track item.id) {
                <tr class="clickable-row" (click)="openEdit(item)" role="button" tabindex="0">
                  <td><code>{{ item.triggerKey }}</code></td>
                  <td>{{ item.channel }}</td>
                  <td>{{ item.headline }}</td>
                  <td>{{ item.active ? 'Yes' : 'No' }}</td>
                  <td (click)="$event.stopPropagation()">
                    <button type="button" class="btn btn-sm btn-outline-danger" (click)="openDeleteConfirm(item)">Delete</button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        @if (sortedContent.length === 0) {
          <p class="text-muted mb-0">No templates yet.</p>
        }
      }
    </div>
  </div>
</div>

@if (detailItem) {
  <div class="modal show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ detailItem.id == null ? 'Create template' : 'Edit template' }}</h5>
          <button type="button" class="btn-close" (click)="closeDetail()"></button>
        </div>
        <div class="modal-body">
          <div class="mb-2">
            <label class="form-label">Trigger key <span class="text-danger">*</span></label>
            <input type="text" class="form-control" [(ngModel)]="detailForm.triggerKey" placeholder="daily_reminder" [readonly]="detailItem.id != null">
          </div>
          <div class="mb-2">
            <label class="form-label">Channel</label>
            <select class="form-select" [(ngModel)]="detailForm.channel">
              @for (channel of channels; track channel) {
                <option [value]="channel">{{ channel }}</option>
              }
            </select>
          </div>
          <div class="mb-2">
            <label class="form-label">Headline <span class="text-danger">*</span></label>
            <input type="text" class="form-control" [(ngModel)]="detailForm.headline" placeholder="Headline">
          </div>
          <div class="mb-2">
            <label class="form-label">Body</label>
            @if (bodyEditor) {
              <ngx-editor-menu [editor]="bodyEditor"></ngx-editor-menu>
              <ngx-editor [editor]="bodyEditor" [(ngModel)]="detailForm.body" outputFormat="html" placeholder="Message body…"></ngx-editor>
            }
          </div>
          <div class="form-check mb-2">
            <input type="checkbox" class="form-check-input" id="templateActive" [(ngModel)]="detailForm.active">
            <label class="form-check-label" for="templateActive">Active</label>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeDetail()">Cancel</button>
          <button type="button" class="btn btn-primary" [disabled]="detailSaving" (click)="save()">Save</button>
        </div>
      </div>
    </div>
  </div>
}

@if (deleteItem) {
  <div class="modal show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Delete template</h5>
          <button type="button" class="btn-close" (click)="closeDeleteConfirm()"></button>
        </div>
        <div class="modal-body">
          @if (deleteError) {
            <div class="alert alert-danger">{{ deleteError }}</div>
          }
          <p>Delete template <strong>{{ deleteItem.triggerKey }}</strong>? This cannot be undone.</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeDeleteConfirm()">Cancel</button>
          <button type="button" class="btn btn-danger" (click)="confirmDelete()">Delete</button>
        </div>
      </div>
    </div>
  </div>
}
